import { AppIntegrationsRepository, MeRepository, DevicesRepository } from 'common/repositories/index';
import Mixpanel from 'common/services/stats/-RFC.Mixpanel';
import { AppInstancesProcessor, DevicesProcessor } from 'common/repositoryProcessors/index';

const _directiveDependencies = [];
const _controllerDependencies = ['$scope', '$state',
    'Util'];

/**
 * @ngdoc service
 * @name directives.ChooseDeviceDeploymentWizardController
 *
 * @description
 * ChooseDeviceDeploymentWizardController
 */
class ChooseDeviceDeploymentWizardController {

    constructor(
        $scope, $state,
        Util,
    ) {

        this.$scope = $scope;
        this.$state = $state;
        this.MeRepository = MeRepository;
        this.DevicesRepository = DevicesRepository;
        this.DevicesProcessor = DevicesProcessor;
        this.AppInstancesProcessor = AppInstancesProcessor;
        this.Util = Util;

        $scope.imgPath = CWCONFIG.imgPath;

        this.app = AppIntegrationsRepository.getById(this.$scope.inputData.appId);
        if (!this.app) {

            // app not found
            this.Util.closeModal();

        }

        this.$scope.displayedDevicesList =
            this.DevicesProcessor.getCompatibleDevices(this.app.id, this.app.attributes.prototype);

        if (!this.$scope.displayedDevicesList.length) {

            this.addNewDevice();

        }

    }

    addNewDeviceFromView() {

        Mixpanel.send('ConnectWeb Add New Device Click', { Page: 'Deployment Modal' });

        this.addNewDevice();

    }


    addNewDevice() {

        const supportedOs =
            AppIntegrationsRepository.getSupportedOs(this.app.id) || ['windows'];

        let stateName = this.$state.current.name;
        if (stateName.indexOf('.deploy') === -1) {

            stateName += '.deploy';

        }

        if (this.$scope.inputData.deployType) {

            // Deploy
            this.$scope.changeWizard()(stateName, {
                resourceId: this.app.id,
                deviceId: 'new',
                os: 'windows',
            }, {
                reload: false,
            });

        } else if (supportedOs.length >= 2) {

            // Choose OS

            this.$scope.changeWizard()(stateName, {
                resourceId: this.$scope.inputData.resourceId || this.$state.params.resourceId,
                appId: this.app.id,
                deviceId: 'new',
            }, {
                reload: false,
            });

        } else {

            // Deploy
            this.$scope.changeWizard()(stateName, {
                resourceId: this.app.id,
                deviceId: 'new',
                os: supportedOs[0],
            }, {
                reload: false,
            });

        }

    }

    /**
     * @ngdoc function
     * @name directives.ChooseDeviceDeploymentWizardController#deployOn
     * @methodOf directives.ChooseDeviceDeploymentWizardController
     * @function
     *
     * @description
     * This function chooses online deployment or offline deployment.
     *
     * @param {Object} device The device object
     */
    deployOn(device) {

        Mixpanel.send('ConnectWeb Existing Device Click', { Page: 'Deployment Modal' });

        this.$scope.deployOnDeviceSuccess()(device, this.app.id, {});

    }

}

class ChooseDeviceDeploymentWizardDirective {

    constructor() {

        this.template = require('./choose-device-deployment-wizard.html');
        this.restrict = 'EA';
        this.replace = true;

        _controllerDependencies.push((
            $scope, $state,
            Util,
        ) =>
            new ChooseDeviceDeploymentWizardController(
                $scope, $state,
                Util,
            ));

        this.controller = _controllerDependencies;
        this.controllerAs = 'chooseDeviceDeploymentWizardCtrl';

    }

}

_directiveDependencies.push(() =>
    new ChooseDeviceDeploymentWizardDirective());

angular.module('directives')
    .directive('chooseDeviceDeploymentWizard', _directiveDependencies);



// WEBPACK FOOTER //
// ./scripts/directives/dashboard/deployment/choose-device-deployment-wizard/choose-device-deployment-wizard.js